function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1.8 2.9998C1.64087 2.9998 1.48826 3.06302 1.37574 3.17554C1.26321 3.28806 1.2 3.44067 1.2 3.5998V10.1998C1.2 10.3589 1.26321 10.5115 1.37574 10.6241C1.48826 10.7366 1.64087 10.7998 1.8 10.7998H8.4C8.55913 10.7998 8.71174 10.7366 8.82426 10.6241C8.93679 10.5115 9 10.3589 9 10.1998V6.5998C9 6.26843 9.26863 5.9998 9.6 5.9998C9.93137 5.9998 10.2 6.26843 10.2 6.5998V10.1998C10.2 10.6772 10.0104 11.135 9.67279 11.4726C9.33523 11.8102 8.87739 11.9998 8.4 11.9998H1.8C1.32261 11.9998 0.864773 11.8102 0.527208 11.4726C0.189642 11.135 0 10.6772 0 10.1998V3.5998C0 3.12242 0.189642 2.66458 0.527208 2.32701C0.864773 1.98945 1.32261 1.7998 1.8 1.7998H5.4C5.73137 1.7998 6 2.06843 6 2.3998C6 2.73118 5.73137 2.9998 5.4 2.9998H1.8Z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M7.19922 0.6C7.19922 0.268629 7.46785 0 7.79922 0H11.3992C11.7306 0 11.9992 0.268629 11.9992 0.6V4.2C11.9992 4.53137 11.7306 4.8 11.3992 4.8C11.0678 4.8 10.7992 4.53137 10.7992 4.2V1.2H7.79922C7.46785 1.2 7.19922 0.931371 7.19922 0.6Z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11.8235 0.175736C12.0578 0.41005 12.0578 0.789949 11.8235 1.02426L5.22348 7.62426C4.98917 7.85858 4.60927 7.85858 4.37495 7.62426C4.14064 7.38995 4.14064 7.01005 4.37495 6.77574L10.975 0.175736C11.2093 -0.0585787 11.5892 -0.0585787 11.8235 0.175736Z"
});

var SvgExternalLink = function SvgExternalLink(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "white",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgExternalLink, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/external-link.57296945.svg";
export { ForwardRef as ReactComponent };